import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Add the following to `}<inlineCode parentName="p">{`composer.json`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "require": {
        "posthog/posthog-php": "3.0.*"
    }
}
`}</code></pre>
    <p>{`And then install the dependencies with the command:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`php composer.phar install
`}</code></pre>
    <p>{`In your app, set your project API key before making any calls.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-php"
      }}>{`PostHog::init("<ph_project_api_key>",
  array('host' => '<ph_instance_address>') // TIP: You can remove this line if you're using app.posthog.com
);
`}</code></pre>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` As a rule of thumb, we do not recommend having API keys in plaintext. Setting it as an environment variable is best.`}</p>
    </blockquote>
    <p>{`You can find your project API key and instance address in the `}<a parentName="p" {...{
        "href": "https://app.posthog.com/project/settings"
      }}>{`project settings`}</a>{` page in PostHog.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      